import { Injectable } from '@angular/core';
import {
  RelatedStrategies,
  InsightsStickyTab,
  StrategiesTab,
} from '@marketing/insights/insights.interface';
import { LocalLinkService } from '@services/local-link.service';
import { ArticleService } from '@marketing/article/services/article.service';
import { Page } from '@bloomreach/spa-sdk/';
import { StickyTab } from '@frk/eds-components';

@Injectable({
  providedIn: 'root',
})
export class StrategyTabsService {
  constructor(
    private localLinkService: LocalLinkService,
    private articleService: ArticleService
  ) {}

  public createStrategyTabsSection(
    strategySectionCompound,
    segmentTags,
    page
  ): RelatedStrategies {
    const rawTabs = strategySectionCompound.localizableStrategyTab;
    let relatedStrategies: RelatedStrategies = {};
    if (
      this.articleService.isSegmentTagAvailable(
        segmentTags,
        strategySectionCompound.targeting
      )
    ) {
      relatedStrategies = {
        heading: strategySectionCompound.heading,
        summary: this.localLinkService.getLocalizeLinks(
          strategySectionCompound.summary?.value
        ),
      };
    }
    relatedStrategies.tabs = this.getStrategyTabs(rawTabs, segmentTags, page);

    return relatedStrategies;
  }

  // Sticky Tabs
  public getStickyNavigation(rawStickyTabs, segmentTags): StickyTab[] {
    const isTargeting = rawStickyTabs.targeting;

    if (this.articleService.isSegmentTagAvailable(segmentTags, isTargeting)) {
      const tabs = rawStickyTabs.links?.map((tab) => ({
        title: tab.heading,
        id: tab.anchor,
      }));

      return tabs;
    }
  }

  // Strategy Tabs
  private getStrategyTabs(
    tabs: Array<StrategiesTab>,
    segmentTags: string,
    page: Page
  ): Array<StrategiesTab> {
    const tabsCollection = [];
    tabs?.forEach((tab) => {
      // Sort tabs is allowed for specific segment
      const isTargeting = tab.targeting;
      if (isTargeting) {
        tab.isAllowed = this.articleService.isSegmentTagAvailable(
          segmentTags,
          isTargeting
        );
      } else {
        tab.isAllowed = true;
      }
      const tabsData = page.getContent(tab.tab)?.getData();

      if (tab.isAllowed) {
        // Considering the tab creation as per required in article collection
        if (tabsData.targetedLinks.length) {
          let tabData = '';
          let linkAllowed = true;
          tabsData.targetedLinks.forEach((tabIn) => {
            if (tabIn?.targeting?.length) {
              const target = JSON.parse(tabIn.targeting);
              if (target) {
                linkAllowed = this.articleService.isSegmentTagAvailable(
                  segmentTags,
                  tabIn.targeting
                );
              } else if (target && !target.toString().length) {
                linkAllowed = true;
              }
            } else if (!tabIn.targeting.length) {
              linkAllowed = true;
            }
            if (linkAllowed) {
              tabData =
                tabData + this.localLinkService.getLocalizeLinks(tabIn.links);
            }
          });
          tabsData.processedContent = tabData;
        }
        // Considering the tab creation as per required in article hub
        if (tabsData.links) {
          tabsData.processedContent = this.localLinkService.getLocalizeLinks(
            tabsData.links
          );
        }
        tabsCollection.push(tabsData);
      }
    });
    return tabsCollection;
  }
}
